import React from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import wuloojLogoFull from "assets/images/superadmin/wulooj-logo-full.png"
import { AUTH_BRAND } from "utils/authPlatform"

const AuthLogoLink = ({
  className = "login-platform-logo mb-4 mt-2",
  alt = AUTH_BRAND,
}) => (
  <div className="text-center">
    <Link to="/" className="d-inline-block auth-logo-link">
      <img src={wuloojLogoFull} alt={alt} className={className} />
    </Link>
  </div>
)

AuthLogoLink.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string,
}

export default AuthLogoLink
